<template>
  <form :class="classes" v-bind="$attrs" @submit="onSubmit">
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: "M4FormOnce",
  data() {
    return {
      submitted: false
    };
  },
  props: {
    invisible: Boolean
  },
  computed: {
    classes() {
      let classes = ["form-once"];
      if (this.invisible) {
        classes.push("form-once--invisible");
      }
      return classes;
    }
  },
  methods: {
    onSubmit(e) {
      if (this.submitted) {
        e.preventDefault();
        return false;
      }
      this.submitted = true;
      return true;
    }
  }
};
</script>
